var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 12a8.25 8.25 0 1 1 16.5 0v.5a1.75 1.75 0 1 1-3.5 0V12a4.75 4.75 0 1 0-.755 2.57 3.25 3.25 0 0 0 5.755-2.07V12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12s4.365 9.75 9.75 9.75a.75.75 0 0 0 0-1.5A8.25 8.25 0 0 1 3.75 12Zm11.5 0a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;